import React, { useEffect, useState } from 'react';
import { CheckCircle2, Clock, ShieldCheck, Star, Droplet, Activity, BookOpen, Gift, ChevronRight, AlertCircle, HeartPulse, Brain, Zap, Utensils, Lock } from 'lucide-react';
import { UgcMarquee } from './components/UgcMarquee';
import { SalesPopup } from './components/SalesPopup';
export function App() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 47,
    seconds: 55
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-900 selection:bg-blue-200" data-id="element-0">
      {/* Pop-up de compras en tiempo real */}
      <SalesPopup data-id="element-1" />

      {/* Top Banner */}
      <div className="bg-red-600 text-white text-center py-2 px-4 font-medium flex items-center justify-center text-[14px] pt-[2px] pb-[2px] pl-[12px] pr-[12px] gap-[5px]" data-id="element-2">
        <Zap size={16} className="animate-pulse" data-id="element-3" />
        OFERTA DE LANZAMIENTO — Precio sube en{' '}
        {String(timeLeft.hours).padStart(2, '0')}:
        {String(timeLeft.minutes).padStart(2, '0')}:
        {String(timeLeft.seconds).padStart(2, '0')} · Solo por hoy
      </div>

      {/* Hero Section */}
      <header className="relative overflow-hidden border-b border-slate-200 bg-gradient-to-b from-blue-50 via-sky-50 to-white pt-6 pb-12 md:pt-12 md:pb-16 px-4" data-id="element-4">
        {/* Soft harmonic background blobs (low opacity) */}
        <div className="pointer-events-none absolute -top-24 -left-24 w-80 h-80 bg-blue-300/30 rounded-full blur-3xl" data-id="element-5" />
        <div className="pointer-events-none absolute top-1/3 -right-24 w-96 h-96 bg-sky-300/25 rounded-full blur-3xl" data-id="element-6" />
        <div className="pointer-events-none absolute bottom-0 left-1/2 -translate-x-1/2 w-[28rem] h-64 bg-amber-200/20 rounded-full blur-3xl" data-id="element-7" />

        <div className="relative max-w-2xl mx-auto space-y-4 md:space-y-6 text-center" data-id="element-8">
          <div className="inline-block bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-xs sm:text-sm font-semibold tracking-wide" data-id="element-9">
            RESET METABÓLICO™
          </div>
          <h1 className="text-2xl sm:text-3xl md:text-5xl font-extrabold text-slate-900 leading-tight" data-id="element-10">
            Estabilizá tu glucosa y bajá tu HbA1c{' '}
            <span className="text-blue-600" data-id="element-11">— sin dietas imposibles</span>
          </h1>

          {/* Image — directly below the headline */}
          <div className="relative max-w-[260px] sm:max-w-sm md:max-w-md mx-auto w-full" data-id="element-12">
            <div className="absolute -inset-3 md:-inset-4 bg-blue-100 rounded-3xl transform rotate-3 -z-10" data-id="element-13"></div>
            <img src="https://cdn.magicpatterns.com/uploads/jNDvVcszxiv8vCNC4q5z5k/ChatGPT_Image_25_jun_2026,_15_18_38.png" alt="Reset Metabólico Método" className="w-full rounded-2xl shadow-2xl" data-id="element-14" />
          </div>

          <p className="md:text-lg text-[13px] text-[#111111]" data-id="element-15">
            El método más claro, práctico y respaldado por la ciencia para
            estabilizar tu glucosa, recuperar tu energía y dejar de vivir con
            miedo a las complicaciones — adaptado 100% a la comida argentina.
          </p>

          <ul className="md:space-y-3 text-left max-w-md mx-auto space-y-[3px]" data-id="element-16">
            {['Sin dietas extremas ni pasar hambre', 'Sin depender solo de las pastillas', 'A tu propio ritmo, desde casa', 'Acceso digital inmediato al comprar'].map((item, i) => <li key={i} className="flex items-start gap-3 text-sm md:text-base text-slate-700 font-medium" data-id="element-17">
                <CheckCircle2 className="text-green-500 shrink-0 mt-0.5" size={20} data-id="element-18" />
                <span data-id="element-19">{item}</span>
              </li>)}
          </ul>

          <div className="pt-2 md:pt-4 space-y-4" data-id="element-20">
            <button onClick={scrollToPricing} className="w-full sm:w-auto bg-blue-600 hover:bg-blue-700 text-white text-base md:text-lg font-bold py-4 px-6 md:px-8 rounded-xl shadow-lg shadow-blue-200 transition-all transform hover:-translate-y-1 flex items-center justify-center gap-2" data-id="element-21">
              <Droplet size={20} className="fill-current" data-id="element-22" />
              QUIERO EMPEZAR MI RESET HOY
            </button>

            <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 text-sm text-slate-500 font-medium" data-id="element-23">
              <div className="flex items-center gap-1" data-id="element-24">
                <Lock size={16} data-id="element-25" /> Pago seguro
              </div>
              <div className="flex items-center gap-1" data-id="element-26">
                <ShieldCheck size={16} data-id="element-27" /> Garantía 30 días
              </div>
              <div className="flex items-center gap-1 text-yellow-500" data-id="element-28">
                <Star size={16} className="fill-current" data-id="element-29" />
                <Star size={16} className="fill-current" data-id="element-30" />
                <Star size={16} className="fill-current" data-id="element-31" />
                <Star size={16} className="fill-current" data-id="element-32" />
                <Star size={16} className="fill-current" data-id="element-33" />
                <span className="text-slate-500 ml-1" data-id="element-34">
                  4.9/5 (+3.000 alumnos)
                </span>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* UGC moving images */}
      <UgcMarquee data-id="element-35" />

      {/* Trust Bar */}
      <div className="bg-slate-900 text-slate-300 py-5 px-4" data-id="element-36">
        <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-4 text-center divide-x divide-slate-700" data-id="element-37">
          <div data-id="element-38">
            <div className="text-2xl font-bold text-white mb-1" data-id="element-39">4.9/5</div>
            <div className="text-sm" data-id="element-40">Calificación lectores</div>
          </div>
          <div data-id="element-41">
            <div className="text-2xl font-bold text-white mb-1" data-id="element-42">+3.000</div>
            <div className="text-sm" data-id="element-43">Personas estabilizadas</div>
          </div>
          <div data-id="element-44">
            <div className="text-2xl font-bold text-white mb-1" data-id="element-45">2 Tomos</div>
            <div className="text-sm" data-id="element-46">+ 4 bonos estratégicos</div>
          </div>
          <div data-id="element-47">
            <div className="text-2xl font-bold text-white mb-1" data-id="element-48">30 días</div>
            <div className="text-sm" data-id="element-49">Garantía total</div>
          </div>
        </div>
      </div>

      {/* Problem Section */}
      <section className="py-12 px-4 bg-white" data-id="element-50">
        <div className="max-w-3xl mx-auto" data-id="element-51">
          <div className="text-center mb-8" data-id="element-52">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-3" data-id="element-53">
              ¿Te suena familiar?
            </h2>
            <p className="text-xl text-slate-600" data-id="element-54">
              ¿Cuánto tiempo más vas a esperar que el análisis mejore solo?
            </p>
          </div>

          <div className="space-y-4" data-id="element-55">
            {[{
            icon: <Clock className="text-orange-500" size={28} data-id="element-56" />,
            title: 'El médico te da 10 minutos',
            desc: "Te renueva la receta, te dice 'hay que aprender a vivir con esto' y te vas con más dudas que respuestas."
          }, {
            icon: <AlertCircle className="text-red-500" size={28} data-id="element-57" />,
            title: 'Hacés todo bien y no baja',
            desc: 'Dejaste el azúcar, el pan, las gaseosas… y la glucosa sigue alta. No entendés por qué y nadie te lo explica.'
          }, {
            icon: <HeartPulse className="text-purple-500" size={28} data-id="element-58" />,
            title: 'El miedo silencioso a las complicaciones',
            desc: 'Cada hormigueo en los pies, cada problema de visión, te hace pensar si ya empezó el daño.'
          }, {
            icon: <Brain className="text-blue-500" size={28} data-id="element-59" />,
            title: 'La información de internet te marea',
            desc: 'Mil dietas contradictorias, consejos sueltos, y ninguna te da un plan claro de qué hacer cada día.'
          }].map((item, i) => <div key={i} className="flex gap-4 p-4 bg-slate-50 rounded-2xl border border-slate-100 hover:border-blue-100 transition-colors" data-id="element-60">
                <div className="shrink-0" data-id="element-61">{item.icon}</div>
                <div data-id="element-62">
                  <h3 className="text-lg font-bold text-slate-900 mb-1" data-id="element-63">
                    {item.title}
                  </h3>
                  <p className="text-slate-600" data-id="element-64">{item.desc}</p>
                </div>
              </div>)}
          </div>

          <div className="mt-6 p-6 bg-blue-50 rounded-2xl text-center border border-blue-100" data-id="element-65">
            <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-66">
              No es falta de voluntad
            </h3>
            <p className="text-blue-800" data-id="element-67">
              Es que nadie te dio un sistema claro, ordenado y respaldado por la
              ciencia para estabilizar tu glucosa día a día.
            </p>
          </div>
        </div>
      </section>

      {/* Solution Section */}
      <section className="py-12 px-4 bg-slate-50" data-id="element-68">
        <div className="max-w-5xl mx-auto" data-id="element-69">
          <div className="text-center mb-8" data-id="element-70">
            <span className="text-blue-600 font-bold tracking-wider uppercase text-sm" data-id="element-71">
              El Método
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mt-2 mb-3" data-id="element-72">
              Reset Metabólico™ — Tu Protocolo en 90 Días
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-73">
              2 Tomos Completos + 4 Bonos Estratégicos. Todo explicado de forma
              simple, sin tecnicismos médicos.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-74">
            {[{
            icon: <Activity data-id="element-75" />,
            title: 'Entendé tus análisis',
            desc: 'Vas a saber leer tu HbA1c, glucosa en ayunas y postprandial sin depender de que el médico te lo explique en 5 minutos.'
          }, {
            icon: <Utensils data-id="element-76" />,
            title: 'Comer sin miedo',
            desc: 'Un plan de 90 días con comida argentina de todos los días — milanesas, guisos, asados — adaptado para no disparar tu azúcar.'
          }, {
            icon: <Zap data-id="element-77" />,
            title: 'Recuperar tu energía',
            desc: 'Estrategias concretas para despertarte descansado/a y volver a sentirte presente con tu familia.'
          }, {
            icon: <ShieldCheck data-id="element-78" />,
            title: 'Proteger tu cuerpo',
            desc: 'Cómo cuidar tus riñones, tu visión y tu circulación desde la alimentación y los hábitos diarios.'
          }, {
            icon: <Brain data-id="element-79" />,
            title: 'Dominar el estrés',
            desc: 'Los factores invisibles que disparan tu glucosa aunque comas perfecto — y cómo controlarlos.'
          }, {
            icon: <HeartPulse data-id="element-80" />,
            title: 'Moverte sin miedo',
            desc: 'Rutinas de ejercicio seguras, sin riesgo de hipoglucemia, adaptadas a tu nivel físico real.'
          }].map((item, i) => <div key={i} className="bg-white p-5 rounded-2xl shadow-sm border border-slate-100" data-id="element-81">
                <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-xl flex items-center justify-center mb-3" data-id="element-82">
                  {item.icon}
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-83">
                  {item.title}
                </h3>
                <p className="text-slate-600" data-id="element-84">{item.desc}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-12 px-4 bg-white" data-id="element-85">
        <div className="max-w-4xl mx-auto" data-id="element-86">
          <div className="text-center mb-8" data-id="element-87">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-88">
              Tu Transformación en 2 Tomos
            </h2>
          </div>

          <div className="space-y-5" data-id="element-89">
            {/* Tomo 1 */}
            <div className="flex flex-col md:flex-row gap-6 bg-slate-50 p-6 rounded-3xl border border-slate-200" data-id="element-90">
              <div className="md:w-1/3 flex flex-col items-center justify-center text-center" data-id="element-91">
                <BookOpen size={56} className="text-blue-600 mb-3" data-id="element-92" />
                <h3 className="text-2xl font-bold text-slate-900" data-id="element-93">Tomo 1</h3>
                <p className="text-blue-600 font-medium" data-id="element-94">Semanas 1 a 6</p>
              </div>
              <div className="md:w-2/3" data-id="element-95">
                <h4 className="text-xl font-bold text-slate-900 mb-2" data-id="element-96">
                  El Despertar Metabólico
                </h4>
                <p className="text-slate-600 mb-4" data-id="element-97">
                  Entendé tu cuerpo, identificá qué está fallando y construí las
                  bases del cambio.
                </p>
                <ul className="space-y-2" data-id="element-98">
                  {['Cómo funciona realmente la diabetes tipo 2', 'Cómo descifrar tus análisis de laboratorio', 'Plan de alimentación semanas 1 a 6', 'Suplementos naturales respaldados por ciencia', 'El triángulo invisible: sueño, estrés y glucosa'].map((item, i) => <li key={i} className="flex items-start gap-2 text-slate-700" data-id="element-99">
                      <ChevronRight className="text-blue-500 shrink-0 mt-0.5" size={20} data-id="element-100" />
                      <span data-id="element-101">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>

            {/* Tomo 2 */}
            <div className="flex flex-col md:flex-row gap-6 bg-slate-50 p-6 rounded-3xl border border-slate-200" data-id="element-102">
              <div className="md:w-1/3 flex flex-col items-center justify-center text-center" data-id="element-103">
                <BookOpen size={56} className="text-blue-800 mb-3" data-id="element-104" />
                <h3 className="text-2xl font-bold text-slate-900" data-id="element-105">Tomo 2</h3>
                <p className="text-blue-800 font-medium" data-id="element-106">Semanas 7 a 12</p>
              </div>
              <div className="md:w-2/3" data-id="element-107">
                <h4 className="text-xl font-bold text-slate-900 mb-2" data-id="element-108">
                  La Transformación Completa
                </h4>
                <p className="text-slate-600 mb-4" data-id="element-109">
                  De la estabilización al control total — para siempre, no solo
                  90 días.
                </p>
                <ul className="space-y-2" data-id="element-110">
                  {['Plan de alimentación semanas 7 a 12', 'Protocolo de ejercicio completo y seguro', '+60 recetas argentinas para diabéticos', 'Plan de mantenimiento de por vida', 'Prevención de complicaciones y salud mental'].map((item, i) => <li key={i} className="flex items-start gap-2 text-slate-700" data-id="element-111">
                      <ChevronRight className="text-blue-500 shrink-0 mt-0.5" size={20} data-id="element-112" />
                      <span data-id="element-113">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Bonuses Section */}
      <section className="py-12 px-4 bg-slate-900 text-white" data-id="element-114">
        <div className="max-w-5xl mx-auto" data-id="element-115">
          <div className="text-center mb-8" data-id="element-116">
            <span className="text-yellow-400 font-bold tracking-wider uppercase text-sm" data-id="element-117">
              Solo por hoy · Con tu compra
            </span>
            <h2 className="text-3xl md:text-4xl font-bold mt-2 mb-4" data-id="element-118">
              4 Bonos Estratégicos GRATIS
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-4" data-id="element-119">
            {[{
            title: 'Protocolo Anti-Inflamación Total',
            desc: 'Apagá el fuego interno que mantiene tu glucosa alta. Incluye protocolo de 21 días + 15 recetas con ingredientes de cualquier super.',
            value: '$12.000'
          }, {
            title: 'Activación Metabólica',
            desc: 'El protocolo de ejercicio seguro para diabéticos, sin miedo a la hipoglucemia, para todos los niveles físicos.',
            value: '$12.000'
          }, {
            title: 'Escudo Protector',
            desc: 'Todo para proteger tus pies, tu piel y tu circulación, y evitar las complicaciones que más se temen.',
            value: '$15.000'
          }, {
            title: 'Libertad Total',
            desc: 'Asados, viajes, cumpleaños y restaurantes sin que la diabetes te robe un solo momento de vida.',
            value: '$15.000'
          }].map((bono, i) => <div key={i} className="bg-slate-800 p-5 rounded-2xl border border-slate-700 relative overflow-hidden" data-id="element-120">
                <div className="absolute top-0 right-0 bg-yellow-500 text-slate-900 text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-121">
                  BONO {i + 1}
                </div>
                <Gift className="text-yellow-400 mb-3" size={32} data-id="element-122" />
                <h3 className="text-xl font-bold mb-2" data-id="element-123">{bono.title}</h3>
                <p className="text-slate-400 mb-4 text-sm" data-id="element-124">{bono.desc}</p>
                <div className="text-sm font-medium" data-id="element-125">
                  <span className="line-through text-slate-500 mr-2" data-id="element-126">
                    {bono.value}
                  </span>
                  <span className="text-green-400" data-id="element-127">GRATIS</span>
                </div>
              </div>)}
          </div>

          <div className="text-center mt-8 text-xl font-bold text-yellow-400" data-id="element-128">
            💰 Valor total de los bonos: $54.000 → ¡GRATIS con tu método!
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="pricing" className="py-12 px-4 bg-slate-50" data-id="element-129">
        <div className="max-w-4xl mx-auto" data-id="element-130">
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-slate-200" data-id="element-131">
            <div className="bg-red-600 text-white text-center py-3 px-4 font-bold flex items-center justify-center gap-2" data-id="element-132">
              <Clock size={20} data-id="element-133" />
              Esta oferta cierra en {String(timeLeft.hours).padStart(2, '0')}:
              {String(timeLeft.minutes).padStart(2, '0')}:
              {String(timeLeft.seconds).padStart(2, '0')}
            </div>

            <div className="p-5 md:p-8" data-id="element-134">
              <div className="text-center mb-5" data-id="element-135">
                <div className="inline-flex items-center gap-1 text-yellow-500 font-bold text-sm bg-yellow-50 px-3 py-1 rounded-full mb-2" data-id="element-136">
                  <Star size={16} className="fill-current" data-id="element-137" /> EL MÁS ELEGIDO
                </div>
                <h2 className="md:text-3xl font-bold text-slate-900 mb-1 text-[23px]" data-id="element-138">
                  Pack Reset Metabólico Completo
                </h2>
                <p className="text-slate-600 text-sm" data-id="element-139">
                  2 Tomos Completos + 4 Bonos Estratégicos
                </p>
              </div>

              <div className="grid md:grid-cols-2 gap-5 mb-5 items-center" data-id="element-140">
                <div className="flex justify-center" data-id="element-141">
                  <img src="https://cdn.magicpatterns.com/uploads/jNDvVcszxiv8vCNC4q5z5k/ChatGPT_Image_25_jun_2026,_15_18_38.png" alt="Pack Completo" className="w-full max-w-[220px] md:max-w-[260px] rounded-xl shadow-md" data-id="element-142" />
                </div>
                <div className="space-y-1.5" data-id="element-143">
                  <div className="font-bold text-slate-900 mb-1" data-id="element-144">
                    ¿Qué incluye?
                  </div>
                  <div className="flex items-center gap-2 text-slate-700 text-sm" data-id="element-145">
                    <CheckCircle2 className="text-green-500 shrink-0" size={18} data-id="element-146" />{' '}
                    TOMO 1: El Despertar Metabólico
                  </div>
                  <div className="flex items-center gap-2 text-slate-700 text-sm" data-id="element-147">
                    <CheckCircle2 className="text-green-500 shrink-0" size={18} data-id="element-148" />{' '}
                    TOMO 2: La Transformación Completa
                  </div>
                  <div className="flex items-center gap-2 text-slate-700 text-sm" data-id="element-149">
                    <Gift className="text-yellow-500 shrink-0" size={18} data-id="element-150" /> BONO
                    1: Protocolo Anti-Inflamación
                  </div>
                  <div className="flex items-center gap-2 text-slate-700 text-sm" data-id="element-151">
                    <Gift className="text-yellow-500 shrink-0" size={18} data-id="element-152" /> BONO
                    2: Activación Metabólica
                  </div>
                  <div className="flex items-center gap-2 text-slate-700 text-sm" data-id="element-153">
                    <Gift className="text-yellow-500 shrink-0" size={18} data-id="element-154" /> BONO
                    3: Escudo Protector
                  </div>
                  <div className="flex items-center gap-2 text-slate-700 text-sm" data-id="element-155">
                    <Gift className="text-yellow-500 shrink-0" size={18} data-id="element-156" /> BONO
                    4: Libertad Total
                  </div>
                </div>
              </div>

              <div className="text-center border-t border-slate-100 pt-5" data-id="element-157">
                <div className="text-slate-500 line-through mb-0.5 text-sm" data-id="element-158">
                  Precio Regular: $59.990
                </div>
                <div className="text-4xl md:text-5xl font-extrabold text-slate-900 mb-1" data-id="element-159">
                  $24.990{' '}
                  <span className="text-lg text-slate-500 font-normal" data-id="element-160">
                    ARS
                  </span>
                </div>
                <p className="text-sm text-slate-500 mb-4" data-id="element-161">
                  Pago único · Acceso inmediato
                </p>

                <a href="https://indigo33.shop/cart/64126108729713:1" className="w-full bg-green-600 hover:bg-green-700 text-white md:text-xl font-bold py-4 px-8 rounded-2xl shadow-xl shadow-green-200 transition-all transform hover:-translate-y-1 flex items-center justify-center gap-2 text-[13px]" data-id="element-162">
                  👉 QUIERO MI RESET METABÓLICO
                </a>

                <div className="flex flex-wrap justify-center gap-4 mt-4 text-xs text-slate-500" data-id="element-163">
                  <span className="flex items-center gap-1" data-id="element-164">
                    <Lock size={14} data-id="element-165" /> Pago seguro
                  </span>
                  <span className="flex items-center gap-1" data-id="element-166">
                    <ShieldCheck size={14} data-id="element-167" /> Garantía 30 días
                  </span>
                  <span className="flex items-center gap-1" data-id="element-168">
                    <BookOpen size={14} data-id="element-169" /> PDF en tu email
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-12 px-4 bg-white" data-id="element-170">
        <div className="max-w-5xl mx-auto" data-id="element-171">
          <div className="text-center mb-8" data-id="element-172">
            <h2 className="text-3xl font-bold text-slate-900 mb-4" data-id="element-173">
              Resultados Reales
            </h2>
            <p className="text-slate-600" data-id="element-174">
              Personas que ya estabilizaron su glucosa
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-5" data-id="element-175">
            {[{
            text: 'En 3 meses mi HbA1c pasó de 11.2 a 6.1. El médico no lo podía creer. Lo mejor es que los cambios son sostenibles, no es una dieta imposible.',
            name: 'Graciela F.',
            loc: 'Córdoba',
            result: 'HbA1c: 11.2 → 6.1 en 90 días',
            initial: 'G'
          }, {
            text: 'Después de 2 meses el médico me redujo la metformina. Mis análisis están como a los 30 años. No pensé que era posible a los 58.',
            name: 'Ricardo M.',
            loc: 'Buenos Aires',
            result: 'Medicación reducida en 2 meses',
            initial: 'R'
          }, {
            text: 'Lo que más me sorprendió es que no tuve que dejar de comer lo que me gusta. Solo cambié el orden y los horarios. Mis análisis mejoraron muchísimo.',
            name: 'Alberto N.',
            loc: 'Santa Fe',
            result: 'Resultados en 60 días',
            initial: 'A'
          }].map((t, i) => <div key={i} className="bg-slate-50 p-5 rounded-2xl border border-slate-100" data-id="element-176">
                <div className="flex text-yellow-400 mb-3" data-id="element-177">
                  {[...Array(5)].map((_, j) => <Star key={j} size={16} className="fill-current" data-id="element-178" />)}
                </div>
                <p className="text-slate-700 italic mb-4" data-id="element-179">"{t.text}"</p>
                <div className="flex items-center gap-3" data-id="element-180">
                  <div className="w-10 h-10 bg-blue-100 text-blue-700 rounded-full flex items-center justify-center font-bold" data-id="element-181">
                    {t.initial}
                  </div>
                  <div data-id="element-182">
                    <div className="font-bold text-slate-900 text-sm" data-id="element-183">
                      {t.name}
                    </div>
                    <div className="text-xs text-slate-500" data-id="element-184">{t.loc}</div>
                  </div>
                </div>
                <div className="mt-4 pt-4 border-t border-slate-200 text-sm font-medium text-green-600 flex items-center gap-1" data-id="element-185">
                  <CheckCircle2 size={16} data-id="element-186" /> {t.result}
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Cost of Waiting */}
      <section className="py-12 px-4 bg-slate-50" data-id="element-187">
        <div className="max-w-3xl mx-auto" data-id="element-188">
          <div className="bg-red-50 border border-red-100 rounded-3xl p-6 md:p-8" data-id="element-189">
            <div className="text-center mb-6" data-id="element-190">
              <h2 className="text-3xl font-bold text-slate-900 mb-3" data-id="element-191">
                El Costo de Esperar
              </h2>
              <p className="text-xl text-red-600 font-medium" data-id="element-192">
                ¿Cuánto cuesta no empezar hoy?
              </p>
            </div>

            <ul className="space-y-3 mb-6" data-id="element-193">
              {['Seguir viendo análisis que no mejoran, mes tras mes.', 'Seguir con el miedo silencioso a las complicaciones en riñones, ojos y circulación.', 'Seguir comiendo con culpa y sin saber qué le hace bien o mal a tu cuerpo.', 'Seguir postergando tu salud porque "no sabés por dónde empezar".'].map((item, i) => <li key={i} className="flex items-start gap-3 text-slate-700" data-id="element-194">
                  <AlertCircle className="text-red-500 shrink-0 mt-0.5" size={20} data-id="element-195" />
                  <span data-id="element-196">{item}</span>
                </li>)}
            </ul>

            <div className="bg-white p-6 rounded-xl border border-red-100 text-center" data-id="element-197">
              <p className="text-slate-800 font-medium" data-id="element-198">
                Cada mes con la HbA1c alta es un mes más de daño silencioso. El
                mejor momento para empezar era ayer.{' '}
                <span className="font-bold text-red-600" data-id="element-199">
                  El segundo mejor es hoy.
                </span>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Guarantee */}
      <section className="py-12 px-4 bg-blue-900 text-white" data-id="element-200">
        <div className="max-w-3xl mx-auto text-center" data-id="element-201">
          <ShieldCheck size={56} className="mx-auto mb-4 text-blue-300" data-id="element-202" />
          <h2 className="text-3xl font-bold mb-4" data-id="element-203">
            Garantía de 30 Días — Sin Preguntas
          </h2>
          <p className="text-blue-100 text-lg leading-relaxed mb-0" data-id="element-204">
            Descargá los dos tomos. Leé los primeros capítulos. Aplicá el plan y
            si sentís que no era lo que esperabas, mandanos un correo y te
            devolvemos el 100% de tu dinero. Sin vueltas, sin llamadas
            incómodas, ni formularios raros. El riesgo corre por nuestra cuenta.
            Tu única tarea es darte la oportunidad de mejorar.
          </p>
        </div>
      </section>

      {/* Footer / Legal */}
      <footer className="bg-slate-950 text-slate-400 py-8 px-4 text-center text-sm" data-id="element-205">
        <div className="max-w-4xl mx-auto space-y-3" data-id="element-206">
          <div className="font-bold text-white text-lg" data-id="element-207">RESET METABÓLICO™</div>
          <p data-id="element-208">© 2026 Reset Metabólico™. Todos los derechos reservados.</p>
          <p className="text-xs text-slate-500 leading-relaxed" data-id="element-209">
            Aviso Legal: Este material es educativo e informativo. No reemplaza
            el consejo, diagnóstico o tratamiento médico profesional. Siempre
            consultá con tu médico antes de realizar cambios en tu dieta,
            medicación o rutina de ejercicio. Los resultados individuales pueden
            variar. Los testimonios presentados son experiencias personales y no
            garantizan resultados similares.
          </p>
        </div>
      </footer>
    </div>;
}